// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-n"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7.5 19L7.5 5L15.5 5C16.0523 5 16.5 5.44772 16.5 6L16.5 19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-n')
export default class LettersNIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-n',
    }
  }
}
